import { call, put, select } from 'redux-saga/effects';
import {
  deleteTaxRateTemplateFailure,
  deleteTaxRateTemplateSuccess,
  getTaxRateTemplatesSuccess,
} from '../actions';
import { deleteTaxRateTemplate } from '../api';
import { DeleteTaxRateTemplateRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { TaxRateTemplate } from '../models';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteTaxRateTemplateSaga(
  action: DeleteTaxRateTemplateRequestAction
) {
  try {
    let err: ApiError | null;
    const { templateId } = action.payload;
    const response: ApiResponse = yield call(deleteTaxRateTemplate, templateId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(deleteTaxRateTemplateSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.tax-rate-template-deleted-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Update the templates list by removing the deleted template
    const currentTemplates: TaxRateTemplate[] = yield select(
      (state) => state.taxRates.taxRateTemplates
    );
    if (currentTemplates) {
      const updatedTemplates = currentTemplates.filter(
        (template) => template.id !== templateId
      );
      yield put(getTaxRateTemplatesSuccess(updatedTemplates));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteTaxRateTemplateFailure());
  }
}

